import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { RegisterForm } from '@/features/auth/components/register-form';

// `haveCode`/`email` let the approver email's resume link drop the applicant
// straight onto the code-entry step with their email prefilled.
const registerSearchSchema = z.object({
  email: z.string().optional(),
  haveCode: z.coerce.boolean().optional(),
});

export const Route = createFileRoute('/_public/register')({
  validateSearch: registerSearchSchema,
  component: RegisterPage,
});

function RegisterPage() {
  const { email, haveCode } = Route.useSearch();
  return <RegisterForm initialEmail={email} startWithCode={haveCode} />;
}
